import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const currencyURL = `api/v1/core-app/currency`;

//obtaining the paginated data
export const getCurrency = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`${currencyURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};
//obtaining all fiscal sessions
export const getAllCurrency = () => axiosInstance.get(`${currencyURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageCurrency = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${currencyURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getCurrencyById = (id) => axiosInstance.get(`${currencyURL}/retrieve/${id}`);

//creating function
export const createCurrency = (body) => axiosInstance.post(`${currencyURL}/create`, body);
//updating function
export const updateCurrency = (id, body) => axiosInstance.patch(`${currencyURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${currencyURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataCurrencyName = (e, cancelToken) =>
  axiosInstance.get(`${currencyURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
